"use client";

import { store } from "@/store";
import { Provider } from "react-redux";
import "mathlive";
import "katex/dist/katex.min.css";

export function ReduxProvider({ children }: { children: React.ReactNode }) {
  return <Provider store={store}>{children}</Provider>;
}
